//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    content: {
      type: Object,
      default: () => ({
        customer: "Nancy Open Air",
        services: ["Identité"],
      }),
    },
  },
};
